module.exports = __webpack_public_path__ + "img/IMG-20191012-WA0273.b1432e3f.jpg";